import React from 'react';
import { useSystemTradingAccounts } from '../hooks/use-system-trading-accounts.js';
import SystemTradingAccountsPageView from './system-trading-accounts-page-view.jsx';

function SystemTradingAccountsPageContainer() {
  const state = useSystemTradingAccounts();
  return <SystemTradingAccountsPageView {...state} />;
}

export default SystemTradingAccountsPageContainer;

